/*global noUiSlider */
const range = {
	el: {
		rangeSlider: document.querySelector('.js-range')
	},

	fxnoUiSlider() {
		if (!this.el.rangeSlider) return
		
		const currentYear = new Date().getFullYear()

		noUiSlider.create(this.el.rangeSlider, {
			start: [2006, currentYear],
			connect: true,
			tooltips: true,
			step: 1,
			format: {
				to: value => {
					return Math.round(value)
				},
				from: value => {
					return Math.round(value)
				}
			},
			range: {
				'min': 2006,
				'max': currentYear
			}
		})
	},

	init() {
		this.fxnoUiSlider()
	}
}

range.init()